import { createContext, useContext } from "react";

export const BusinessConfigContext = createContext(null);

export const useBusinessConfig = () => useContext(BusinessConfigContext);
